exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-sizes .el-select-dropdown__item.out-of-stock:after{content:\" - Out of Stock\"}.product-sizes .el-select-dropdown__item.out-of-stock>span{color:red;text-decoration:line-through}", ""]);

// exports
